var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", { staticClass: "is-size-5 store-navigation-color" }, [
        _vm._v(_vm._s(_vm.location.name))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }, [
          _c("div", { staticClass: "level-item" }, [
            _c("p", [_vm._v(_vm._s(_vm.location.address))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-right" }, [
          _c("div", { staticClass: "level-item" }, [
            _c(
              "a",
              {
                staticClass: "store-loyalty-color",
                attrs: { id: "change-store-txt" },
                on: {
                  click: function($event) {
                    return _vm.$emit("change-location")
                  }
                }
              },
              [_vm._v("Change Store")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.location.id
        ? _c("BaseMap", { attrs: { location: _vm.location } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69352fca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69352fca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/store-locator/LocationDetail.vue
// module id = null
// module chunks = 